"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeServerErrors = void 0;
const utils_1 = require("./utils");
function normalizeServerErrors(exception) {
    const errors = {};
    const rawErrors = exception.errors || exception.message || exception;
    if (Array.isArray(rawErrors)) {
        // Keep only the first error.
        for (const rawError of rawErrors) {
            if (!errors.__form) {
                errors.__form = rawError;
                return errors;
            }
        }
    }
    else if ((0, utils_1.isObject)(rawErrors)) {
        for (const [k, v] of Object.entries(rawErrors)) {
            errors[k] = v;
        }
    }
    else {
        errors.__form = rawErrors;
    }
    return errors;
}
exports.normalizeServerErrors = normalizeServerErrors;
//# sourceMappingURL=errors.js.map